module.exports = __webpack_public_path__ + "static/media/csm-vest.134aee70.svg";